import React from "react";
import { HashRouter } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import Spinner from "../templates/loader";
import "react-toastify/dist/ReactToastify.css";
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css';
import "./style.css"
import ContextWrapper from "../context";
import Routes from "../routes";

const App = () => {
  return (
    <HashRouter>
      <ContextWrapper>
        <Routes />
        <Tooltip id="my-tooltip" />
        <ToastContainer />
        <Spinner />
      </ContextWrapper>
    </HashRouter>
  );
};

export default App;
